import { useCallback, useMemo } from "react";

import { useApi } from "shared/services/api/useApi";

export const useAgencies = () => {
    const { getDataAsync } = useApi();

    const getAgenciesFilter = useCallback(async (params) => {

        const payload = await getDataAsync("agenciesFilter", { params: params });
        return payload.json();
        
    }, [getDataAsync]);

    return useMemo(() => {
        return { getAgenciesFilter };
    }, [getAgenciesFilter]);
};
